import {Component, OnInit} from '@angular/core';
import {MessageService} from '../message.service';
import {Subject, Subscription, Observable} from 'rxjs';
import {RestApiService} from '../rest-api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {NotifierService} from 'angular-notifier';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {
    private notifier: NotifierService;
    respObject: any;
    masterCategory = [];
    clientId: number;
    clientName: string;
    faqDtls = [];
    panelOpenState = false;
    private userAuth: Subscription;
    searchVal: string;
    searchDtls = [];


    constructor(private messageService: MessageService, private _rest: RestApiService,
                private route: Router, notifier: NotifierService,
                private modalService: NgbModal, private actRoute: ActivatedRoute) {
    }

    ngOnInit() {
        this.searchVal = '';
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.clientName = this.messageService.client;
            this.getFaqMasterCategory(this.clientId);
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.clientId = auth[0].clientId;
                this.clientName = auth[0].client;
                this.getFaqMasterCategory(this.clientId);
            });
        }
    }

    changeRouting() {
        if (this.messageService.dashboardUrl !== undefined && this.messageService.dashboardUrl !== null) {
            this.messageService.changeRouting(this.messageService.dashboardUrl);
        }
        // this.route.navigate(['ticket/dashboard']);
    }

    getFaqMasterCategory(clientId) {
        this._rest.getFaqCategory(clientId).subscribe((res) => {
            this.respObject = res;
            this.masterCategory = this.respObject.details;
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }


    searchFaq(value) {
        if (value.length > 2) {
            this._rest.getFaqSearchData(this.clientId, value, this.messageService.getUserId()).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.searchDtls = this.respObject.details;
                }
            }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        } else if (value.length === 0) {
            this.searchDtls = [];
        }
    }

    openGroup(id) {
        const idd = 'li_' + id;
        const ul = document.getElementById(idd);
        ul.innerText = '';
        this._rest.getFaqDetails(this.clientId, id).subscribe((res) => {
            this.respObject = res;
            this.faqDtls = this.respObject.details;
            for (let i = 0; i < this.faqDtls.length; i++) {
                const qus = document.createElement('p');
                qus.className = 'question mar-bot-5';
                qus.innerHTML = this.faqDtls[i].questions;
                const ans = document.createElement('p');
                ans.innerHTML = this.faqDtls[i].answers;
                ans.className = 'faq-ans mar-bot-5';
                //  console.log("aaaaa"+ans);
                ul.appendChild(qus);
                ul.appendChild(ans);
            }

        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }
}
